const BackgroundColour = (props) => {
  switch (props) {
    case "red":
      return "bg-red text-white";
    case "lightblue":
      return "bg-lightblue text-white";
    case "darkblue":
      return "bg-darkblue text-white";
    case "lightteal":
      return "bg-lightteal text-white";
    case "teal":
      return "bg-teal text-white";
    case "darkorange":
      return "bg-darkorange text-white";
    case "mustard":
      return "bg-mustard text-white";
    case "pink":
      return "bg-pink text-white";
    default:
      return "bg-darkgrey text-white";
  }
};

const TitleColour = (props) => {
  switch (props) {
    case "red":
      return "text-red";
    case "lightblue":
      return "text-lightblue";
    case "darkblue":
      return "text-darkblue";
    case "lightteal":
      return "text-lightteal";
    case "teal":
      return "text-teal";
    case "darkorange":
      return "text-darkorange";
    case "mustard":
      return "text-mustard";
    case "pink":
      return "text-pink";
    case "darkgrey":
      return "text-darkgrey";
    default:
      return "text-red";
  }
};

const TextColour = (props) => {
  switch (props) {
    case "steelblue":
      return "text-steelblue";
    case "teal":
      return "text-teal";
    case "burntorange":
      return "text-burntorange";
    case "mustard":
      return "text-mustard";
    case "red":
      return "text-red";

    default:
      return "text-darkgrey";
  }
};

const BoldColour = (props) => {
  switch (props) {
    case "red":
      return "redBold";
    case "lightblue":
      return "lightblueBold";
    case "darkblue":
      return "darkblueBold";
    case "lightteal":
      return "lighttealBold";
    case "teal":
      return "tealBold";
    case "darkorange":
      return "darkorangeBold";
    case "mustard":
      return "mustardBold";
    case "pink":
      return "pinkBold";
    default:
      return "";
  }
};

const ButtonColour = (props, invert) => {
  switch (props) {
    case "pink":
      return invert
        ? "!text-pink !bg-white hover:!text-pink hover:!bg-yellow"
        : "!text-pink !bg-yellow hover:!text-pink hover:!bg-white";
    case "yellow":
      return invert
        ? "!text-pink !bg-white hover:!text-yellow hover:!bg-pink"
        : "!text-yellow !bg-pink hover:!text-pink hover:!bg-white";
    case "lightblue":
      return invert
        ? "!text-darkblue !bg-white hover:!text-white hover:!bg-darkblue"
        : "!text-white !bg-darkblue hover:!text-darkblue hover:!bg-white";
    case "darkblue":
      return invert
        ? "!text-pink !bg-white hover:!text-white hover:!bg-pink"
        : "!text-white !bg-pink hover:!text-pink hover:!bg-white";
    default:
      return invert
        ? "!text-darkblue !bg-white hover:!text-white hover:!bg-darkblue"
        : "!text-white !bg-pink hover:!text-pink hover:!bg-white";
  }
};

const ArrowButtonColour = (props) => {
  switch (props) {
    case "pink":
      return "!text-white hover:!text-yellow";
    case "yellow":
      return "!text-pink hover:!text-darkblue";
    case "lightblue":
      return "!text-white hover:!text-darkblue";
    case "darkblue":
      return "!text-white hover:!text-pink";
    default:
      return "!text-white hover:!text-pink";
  }
};

const LinkColour = (props) => {
  switch (props) {
    case "pink":
      return "hover:text-yellow";
    case "yellow":
      return "hover:text-pink";
    case "lightblue":
      return "hover:text-white";
    case "darkblue":
      return "hover:text-pink";
    default:
      return "hover:text-pink";
  }
};

const SliderArrowColour = (props) => {
  switch (props) {
    case "pink":
      return "bg-yellow text-pink";
    case "yellow":
      return "bg-darkblue text-white";
    case "lightblue":
      return "bg-darkblue text-white";
    case "darkblue":
      return "bg-pink text-white";
    default:
      return "bg-darkblue text-white";
  }
};

const HrColour = (props) => {
  switch (props) {
    case "pink":
      return "border-yellow";
    case "yellow":
      return "border-darkblue";
    case "lightblue":
      return "border-darkblue";
    case "darkblue":
      return "border-pink";
    default:
      return "border-pink";
  }
};

const ArrowColour = (props) => {
  switch (props) {
    case "pink":
      return "text-white group-hover:text-pink";
    case "yellow":
      return "text-white group-hover:text-darkblue";
    case "lightblue":
      return "text-white group-hover:text-darkblue";
    case "darkblue":
      return "text-white group-hover:text-pink";
    default:
      return "text-white group-hover:text-pink";
  }
};

const HoverColour = (props) => {
  switch (props) {
    case "steelblue":
      return "hover:text-steelblue";
    case "teal":
      return "hover:text-teal";
    case "burntorange":
      return "hover:text-burntorange";
    case "mustard":
      return "hover:text-mustard";
    case "red":
      return "hover:text-red";
    default:
      return "hover:text-darkgrey";
  }
};

const TagColour = (props) => {
  switch (props) {
    case "Marketing":
      return "bg-red";
    case "Creative":
      return "bg-teal";
    default:
      return "bg-darkgray";
  }
};

export {
  BackgroundColour,
  TitleColour,
  BoldColour,
  ButtonColour,
  ArrowButtonColour,
  LinkColour,
  SliderArrowColour,
  HrColour,
  ArrowColour,
  TextColour,
  HoverColour,
  TagColour,
};
